import Table from "./Table";

export { default as Table1Dimension } from "./Table1Dimension";
export { default as Table2Dimensions } from "./Table2Dimensions";
export { default as Table3Dimensions } from "./Table3Dimensions";
export { default as TableNDimensions } from "./TableNDimensions";

export default Table;
